export const toEmailContact = lead => ({
  firstName: lead.contactFirstName,
  lastName: lead.contactLastName,
  email: lead.email
})
